import Experience from "../Experience";

export default class Airports {
  constructor () {
    this.experience = new Experience();
    this.resources = this.experience.resources;
    this.container = document.querySelector(".layers");

    this.setInstances();
  }

  setInstances () {
    this.growth = this.resources.items.growthAirport;
    this.container.appendChild(this.growth);

    this.hybrid = this.resources.items.hybridAirport;
    this.container.appendChild(this.hybrid);

    this.standard = this.resources.items.standardAirport;
    this.container.appendChild(this.standard);
  }
}